/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Workspace_Aside_ScoringInputs */

const en_directory_submit_workspace_aside_scoring = /** @type {(inputs: Directory_Submit_Workspace_Aside_ScoringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform review and scoring`)
};

const zh_directory_submit_workspace_aside_scoring = /** @type {(inputs: Directory_Submit_Workspace_Aside_ScoringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`平台审核和评分`)
};

/**
* | output |
* | --- |
* | "Platform review and scoring" |
*
* @param {Directory_Submit_Workspace_Aside_ScoringInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_workspace_aside_scoring = /** @type {((inputs?: Directory_Submit_Workspace_Aside_ScoringInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Workspace_Aside_ScoringInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_workspace_aside_scoring(inputs)
	return zh_directory_submit_workspace_aside_scoring(inputs)
});
export { directory_submit_workspace_aside_scoring as "directory.submit.workspace.aside.scoring" }